import { createContext } from 'react';

export type PatchedFieldsContextValue = {
  fields: readonly string[];
  pulseParity: Readonly<Record<string, number>>;
};

const empty: PatchedFieldsContextValue = {
  fields: [],
  pulseParity: {},
};

export const PatchedFieldsContext = createContext<PatchedFieldsContextValue>(empty);
